import { apiQuery } from '../';

export const chatGtp = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      chatGtpMessage: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/open_ai/generate_step',
            method: 'post',
            data: payload,
          };
        },
      }),
      templateGeneration: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/templates/generate',
            method: 'post',
            data: payload,
          };
        },
      }),
      templateReGeneration: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/templates/regenerate',
            method: 'put',
            data: payload,
          };
        },
      }),
      generationStatus: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/templates/generation_status',
            method: 'get',
            params: payload,
          };
        },
      }),
      getPersonalizedFlows: builder.query({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/contacts/${payload?.candidateId}/reviewable_outreaches`,
            method: 'get',
          };
        },
      }),
      getFlowPreview: builder.query({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/contacts/${payload?.contactId}/personalised_steps`,
            method: 'get',
            params: { outreach_id: payload?.outreachId },
          };
        },
      }),
      getFlowPreviews: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/contacts/${payload?.contactId}/personalised_steps`,
            method: 'get',
            params: { outreach_id: payload?.outreachId },
          };
        },
      }),
      getAllFlowPreviews: builder.mutation({
        transformResponse: (response) => response?.data?.steps_info,
        query: (payload) => {
          return {
            url: `/outreaches/${payload?.outreachId}/candidates/${payload?.contactId}/personalised_steps`,
            method: 'get',
          };
        },
      }),
      updateAiMeessage: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/ai_messages`,
            method: 'put',
            data: payload,
          };
        },
        invalidatesTags: ['GetOutreachCandidates'],
      }),
      retryAiMessage: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/ai_messages/${payload?.aiMessageId}/retry`,
            method: 'put',
          };
        },
      }),
      aiMessageGenerationStatus: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/ai_messages/${payload?.aiMessageId}/status`,
            method: 'get',
          };
        },
      }),
      generateStepPersonalisation: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/ai_messages/personalise_li`,
            method: 'post',
            data: { ...payload },
          };
        },
      }),
      aiMessageFeedback: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/ai_messages/${payload?.aiMessageId}/feedback`,
            method: 'put',
            data: {
              feedback: payload?.feedback,
              feedback_text: payload?.feedbackText,
            },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useChatGtpMessageMutation,
  useTemplateGenerationMutation,
  useTemplateReGenerationMutation,
  useGenerationStatusMutation,
  useGetFlowPreviewQuery,
  useGetFlowPreviewsMutation,
  useGetAllFlowPreviewsMutation,
  useGetPersonalizedFlowsQuery,
  useUpdateAiMeessageMutation,
  useRetryAiMessageMutation,
  useAiMessageGenerationStatusMutation,
  useAiMessageFeedbackMutation,
  useGenerateStepPersonalisationMutation,
} = chatGtp;
